import React from 'react'
import MultiStepForm from '../components/formix'
import "./multipage.css"

function Multi() {
  return (
    <div className='step-holder'>

      <div className='central-section'>

      <MultiStepForm/>

      </div>
    </div>
  )
}

export default Multi